<template>
	<div>
		<div class="integration-accounts" v-if="accounts.length !== 0">
			<div class="integration-account" v-for="(account, index) in accounts" :key="index">
				<div class="wrapper">
					<div class="integration-account__name">
						<slot v-bind:account="account">
							<!-- Fallback content -->
							{{ account.account_name }}
						</slot>
					</div>
					<div class="integration-account__actions">
						<button type="button" class="integration-account__edit btn-plain" @click="edit(account, index)" v-tooltip="'Edit'" v-if="editable"><i class="material-icons">edit</i></button>
						<button type="button" class="integration-account__remove btn-plain btn-icon-danger" @click="remove(account, index)" v-tooltip="'Remove'"><i class="material-icons">close</i></button>
					</div>
				</div>
			</div>
		</div>
		<div class="integration-accounts-empty p-4 text-center" v-if="accounts.length === 0">{{ emptyListMessage }}</div>
	</div>
</template>

<script>
export default {
	name: 'integrationAccounts',
	props: {
		name: {
			type: String,
			default: 'Account',
		},
		accounts: {
			type: Array,
			default: () => [],
		},
		emptyMessage: {
			type: String,
			default: 'No accounts connected yet.',
		},
		editable: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		edit(account, index) {
			const key = account._id ? account._id : index;
			this.$emit('edit', key);
		},
		remove(account, index) {
			const removedKey = account._id ? account._id : index;
			this.$emit('remove', removedKey);
		},
	},
	computed: {
		defaultEmptyMesage() {
			return `No ${this.name} Connected`;
		},
		emptyListMessage() {
			return this.emptyMessage ? this.emptyMessage : this.defaultEmptyMesage;
		},
	},
};
</script>
